import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles/multiselect.css';
import './styles/checkbox.css';
import './styles/nepcTheme.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
